import React from 'react'
import OrderItems from '../Components/OrderItems/OrderItems'

const Order = () => {
  return (
    <div>
      <OrderItems/>
    </div>
  )
}

export default Order